import { createSlice } from '@reduxjs/toolkit';

export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    loading: false,
    error: '',
    snack: {
      type: '',
      status: false,
      position: {
        vertical: 'top',
        horizontal: 'center',
      },
      message: '',
    },
    sideBar: true,
  },
  reducers: {
    activeSnack: (state, action) => {
      state.snack.status = true;
      state.snack.type = action.payload.type;
      state.snack.message = action.payload.message;
    },
    hideSnack: (state) => {
      state.snack.status = false;
    },
    activeSideBar: (state) => {
      state.sideBar = true;
    },
    hideSideBar: (state) => {
      state.sideBar = false;
    },
  },
});
export const { activeSnack, hideSnack, activeSideBar, hideSideBar } = commonSlice.actions;

export default commonSlice.reducer;
